import React from 'react';
import { BaseChat } from './chat/BaseChat';

export const OnboardingChat: React.FC = () => {
  return (
    <BaseChat
      endpoint="/ws/onboarding/"
      queryParams={{}}
    />
  );
};
